<dx-popup
    #transactionLog
    minWidth="150px"
    minHeight="150px"
    width="50%"
    height="65%"
    [title]="title"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopClose()"
>
    <dx-box height="100%" width="100%" direction="col">
        <dxi-item [ratio]="1">
            <dx-data-grid
                width="100%"
                height="100%"
                [dataSource]="transactionLogResultData"
                [allowColumnReordering]="true"
                [allowColumnResizing]="true"
                [columnAutoWidth]="true"
                [showBorders]="true"
                [showColumnLines]="true"
                [showRowLines]="true"
                noDataText="No data to display"
            >
                <dxi-column dataField="userAction" caption="User Action" dataType="string" [width]="115"></dxi-column>
                <dxi-column
                    dataField="updatedDate"
                    caption="Updated Date"
                    dataType="date"
                    [width]="145"
                    [format]="dateTimeFormat"
                ></dxi-column>
                <dxi-column
                    dataField="updatedByDisplayText"
                    caption="Updated By"
                    dataType="string"
                    [width]="130"
                    cellTemplate="userBioTemplate"
                ></dxi-column>
                <dxi-column dataField="description" dataType="string" caption="Description"></dxi-column>

                <div *dxTemplate="let row of 'userBioTemplate'">
                    <app-user-bio-link [user]="row.data.updatedBy" [communityId]="communityId"></app-user-bio-link>
                </div>

                <dxo-header-filter [visible]="true"></dxo-header-filter>
                <dxo-filter-panel [visible]="true"></dxo-filter-panel>
                <dxo-group-panel [visible]="false"></dxo-group-panel>
                <dxo-sorting mode="none"></dxo-sorting>
                <dxo-scrolling mode="standard"></dxo-scrolling>
                <dxo-load-panel [enabled]="false"></dxo-load-panel>
            </dx-data-grid>
        </dxi-item>
        <dxi-item baseSize="auto">
            <div *dxTemplate class="button-container">
                <dx-toolbar>
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Close"
                                [icon]="iconClose"
                                (onClick)="onPopClose()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </div>
        </dxi-item>
    </dx-box>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#transactionLog' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
